import React, { useState, Suspense } from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import logo from '../assets/images/logo.png';
import '../styles/Dashboard.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faCog, faSignOutAlt, faBars, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from './AuthContext';

const DashboardLayout = () => {
    const { user, setUser } = useAuth();
    const [activeMenu, setActiveMenu] = useState('');
    const [activeSubmenu, setActiveSubmenu] = useState('');
    const [sidebarOpen, setSidebarOpen] = useState(false); // Sidebar is closed by default
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('user');
        setUser(null);
        navigate('/Login');
    };

    const menus = [
        // Example menu items
        // {
        //     name: 'Certificates',
        //     submenus: [
        //         { name: 'Birth Certificate', path: '/birth-certificate' },
        //         { name: 'Death Certificate', path: '/death-certificate' },
        //     ],
        // },
        // {
        //     name: 'Reports',
        //     submenus: [
        //         { name: 'Ledger', path: '/ledger' },
        //         { name: 'Summary', path: '/summary' },
        //     ],
        // },
    ];

    const handleMenuClick = (menuName) => {
        if (sidebarOpen) {
            setActiveMenu((prev) => (prev === menuName ? '' : menuName));
            setActiveSubmenu('');
        }
    };

    const handleSubmenuClick = (path) => {
        if (sidebarOpen) {
            navigate(path);
        }
    };

    return (
        <div className={`dashboard-container ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
            <aside className="dashboard-sidebar">
                <div className="sidebar-header">
                    <div className="logo-container">
                        <img src={logo} alt="E-AC Logo" className={`logo ${!sidebarOpen ? 'logo-small' : ''}`} />
                        <h2 className="sidebar-title">{sidebarOpen ? 'E-AC | Dashboard' : ''}</h2>
                    </div>
                </div>
                <nav className="sidebar-nav">
                    <ul>
                        <li>
                            <Link to="/" className={`nav-link ${activeMenu === '' ? 'active' : ''}`}>
                                <FontAwesomeIcon icon={faHome} />
                                {sidebarOpen && <span className="menu-label">Dashboard</span>}
                            </Link>
                        </li>
                        {menus.map((menu) => (
                            <li key={menu.name}>
                                <a
                                    className={`nav-link ${activeMenu === menu.name ? 'active' : ''} ${
                                        !sidebarOpen ? 'disabled' : ''
                                    }`}
                                    onClick={() => handleMenuClick(menu.name)}
                                >
                                    <FontAwesomeIcon icon={faFileAlt} />
                                    {sidebarOpen && <span className="menu-label">{menu.name}</span>}
                                </a>
                                {activeMenu === menu.name && (
                                    <div className="submenu-box">
                                        {menu.submenus.map((submenu) => (
                                            <a
                                                key={submenu.name}
                                                className={`submenu-link ${!sidebarOpen ? 'disabled' : ''}`}
                                                onClick={() => sidebarOpen && handleSubmenuClick(submenu.path)}
                                            >
                                                {submenu.name}
                                            </a>
                                        ))}
                                    </div>
                                )}
                            </li>
                        ))}
                    </ul>
                </nav>
            </aside>
            <main className="dashboard-main">
                <header className="main-header">
                    <button className="toggle-sidebar-btn" onClick={() => setSidebarOpen(!sidebarOpen)}>
                        <FontAwesomeIcon icon={faBars} />
                    </button>
                    <div className="breadcrumb">
                        <span>Dashboard</span>
                        {activeMenu && <span> / {activeMenu}</span>}
                        {activeSubmenu && <span> / {activeSubmenu}</span>}
                    </div>
                </header>
                <section className="main-content">
                    <Suspense fallback={<div>Loading...</div>}>
                        <Outlet />
                    </Suspense>
                </section>
            </main>
        </div>
    );
};

export default DashboardLayout;
